import { Navigate, Route, Routes } from 'react-router';
import Index from '../pages/index';
import QuestionSets from '../pages/questionSets/pages/questionSets';
import AddQuestionsIndex from '../pages/questionSets/pages/addQuestions/index';
import { MyContentProvider } from './myContentContext';
import AddMcFillInQuestion from '../pages/AddMcFillInQuestion';
import ResourceSet from '../pages/resourceSets/components/resourceSet/resourceSet';
import QuestionsSearch from '../pages/questionSets/utils/questionSearchRoute';
import ResourceSets from '../pages/resourceSets/pages/resourceSets';
import AddCRQuestion from '../pages/questionSets/pages/AddCRQuestion';
import FlashcardSets from '../pages/flashcardSets/pages/flashcardSets';
import DisplaySet from '../components/DisplaySet';
import FlashCards from '../components/FlashCards';
import AddFlashCard from '../components/AddFlashCard';
import DisplayQuestionSet from '../pages/questionSets/pages/DisplayQuestionSet';

const MyContentRoute = () => {
  return (
    <MyContentProvider>
      <Routes>
        <Route path="/" element={<Index />}>
          <Route index element={<Navigate to="questionsets" />} />
          <Route path="questionsets" element={<QuestionSets />} />
          <Route path="resourcesets" element={<ResourceSets />} />
          <Route path="flashcardsets" element={<FlashcardSets />} />
        </Route>
        <Route path="questionsets/:setId/questions" element={<AddQuestionsIndex />} />
        <Route path="questionsets/:setId?/mc_fillInQuestion/:questionId?/:courseId?" element={<AddMcFillInQuestion />} />
        <Route path="questionsets/:setId?/cr_Question/:questionId?/:courseId?" element={<AddCRQuestion />} />
        <Route path="questionsets/:setId/displayset" element={<DisplayQuestionSet />} />
        <Route path="resourcesets/:setId" element={<ResourceSet />} />
        <Route element={<QuestionsSearch />} path="questionsets/questionsSearch/*" />
        <Route path="flashcardsets/:setId?/flashcards" element={<FlashCards />} />
        <Route path="flashcardsets/:setId/displayset" element={<DisplaySet />} />
        <Route path="flashcardsets/:setId?/flashcards/:flashcardId?/addflashcard" element={<AddFlashCard />} />
      </Routes>
    </MyContentProvider>
  );
};

export default MyContentRoute;